import React from"react";

const features = [
 {
 title:"📚 90+ Technologies MCQs",
 description:
"Explore a world of 90+ cutting-edge technologies spanning Artificial Intelligence, Machine Learning, Cloud Computing, Frontend & Backend Development, Databases, DevOps, Cybersecurity, and Emerging Tech. Each technology is organized into 20 structured levels — guiding you from beginner basics to expert problem-solving. You can start your journey absolutely free with the first 6 levels to build a strong foundation. When you're ready to go further, unlock the remaining 14 levels for just ₹299 and continue your mastery. Every question offers instant feedback to help you learn in real time, and if you get stuck, just tap the 'Explain' button for a detailed breakdown of the concept. Once you complete the test mode, you'll unlock a personalized 'Evaluate' report that shows exactly where you shine and what to improve. It’s more than practice — it’s a complete path to tech excellence."
 },
 {
 title:"🚀 20 Launchpad Skills",
 description:
"At TheSkillGenie, our 20 Launchpads are more than courses — they’re career blueprints. Each one is built around real tech roles like AI Engineer, Cloud Architect, DevOps Pro, or Full Stack Developer. You’ll tackle 20 levels of role-specific MCQs, with the first 5 levels completely free to explore. Ready for the real challenge? Unlock Levels 6–20 for just ₹399 and access advanced content, smart explanations, and growth evaluations. Learn, practice, and evolve — all mapped to your dream job. This isn’t just upskilling, it’s your launch into the tech future."
 },
 {
 title:"📘 TheSkillGenie Technology Docs (25 Technologies)",
 description:
"Unlock deep, structured documentation for 25 essential technologies — available after your ₹299 upgrade. These docs go beyond summaries, offering real-world concepts, interview-ready insights, and detailed notes for: Java, Python, JavaScript, C++, AI, Machine Learning, Deep Learning, NLP, AWS, Azure, Google Cloud, R, MongoDB, PostgreSQL, MySQL, React, Node.js, Data Science, Dart, CI/CD, Computer Networks, Operating Systems, DevOps, Blockchain, and System Design. Perfect for revision, certification prep, and job interviews — everything you need, all in one place."
 },
 {
 title:"📂 TheSkillGenie Launchpad Docs (5 Core Roles)",
 description:
"Alongside MCQs, each premium Launchpad comes with in-depth documentation for real job roles: Java Developer, AI Engineer, Quantum Computing Learner, QA Tester, and Cloud Architect. These structured docs cover everything from tools and workflows to challenges and best practices — helping you not just learn the skills, but understand the responsibilities. It's your job guide, study kit, and interview reference — all rolled into one powerful resource."
 },
 {
 title:"🧑‍💻 Practice Compiler",
 description:
"Run and test code in-browser with our real-time compiler. Supports multiple languages like Python, Java, C++, and more. Write, debug, and iterate without any external setup. Great for interview prep or concept reinforcement. Integrated with SkillGenie's learning flow. Fast, responsive, and beginner-friendly."
 },
 {
 title:"🕵️‍♂️ Coding Challenges",
 description:
"Not just coding — solve mystery challenges with hidden test cases. Each problem tests logic, optimization, and creativity. Earn XP by passing all levels under given constraints. Encourages critical thinking under pressure. Perfect for competitive coders. The ultimate skill test for future tech leaders."
 },
 {
 title:"🎓 About Bootcamp",
 description:
"Join TheSkillGenie Bootcamp — an intensive, hands-on learning experience designed to accelerate your tech career. Our bootcamps offer structured paths in Technologies, Tech Bunches, Certifications, and Role-based training (both Individual and Team modes). Choose from beginner to advanced experience levels, work on real-world projects, collaborate with peers, and get personalized guidance from industry experts. Whether you're starting fresh or leveling up, our bootcamp provides the structure, support, and resources you need to succeed. Track your progress, earn certificates, and build a portfolio that showcases your skills to employers. Your journey from learner to professional starts here."
 }
];

const FeaturesOverview = () => {
 return (
 <div className="bg-bgMain text-body min-h-screen py-12 px-6 md:px-16 lg:px-32 font-sans">
 <h1 className="text-4xl md:text-6xl font-black text-heading mb-10 text-center uppercase tracking-tighter">
 ✨ <span className="text-primary">TheSkillGenie</span> Features
 </h1>
 
 {/* Current Features */}
 <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
 {features.map((feature, index) => (
 <div
 key={index}
 className="bg-white border-t-4 border-primary p-8 rounded-3xl shadow-card hover:shadow-elevated transition-all border border-accentGray/20 group"
 >
 <h2 className="text-2xl font-bold mb-4 text-heading leading-tight group-hover:text-primary transition-colors">
 {feature.title}
 </h2>
 <p className="text-body text-base font-medium leading-relaxed">
 {feature.description}
 </p>
 </div>
 ))}
 </div>
 </div>
 );
};

export default FeaturesOverview;



